// Copyright ©️ 2026 eVolve MEP, LLC

import { Card, Flex, LoadingOverlay, Text } from '@mantine/core';

type Props = {
  title: string;
  value: string | number | null | undefined;
  subtitle?: string;
  loading?: boolean;
};

export const SummaryCard = ({ title, subtitle, value, loading }: Props) => (
  <Card withBorder flex={1} mah={150}>
    <Flex h="100%" direction="column" justify="space-between">
      <Text c="dimmed" fz="sm">
        {title}
      </Text>
      <Text fz={30} fw={600}>
        {typeof value === 'number' ? value.toFixed(0) : (value ?? '--')}
      </Text>
      <Text c="dimmed" fz="sm">
        {subtitle}
      </Text>
    </Flex>
    <LoadingOverlay visible={loading} />
  </Card>
);
